import { Currency } from '@/core/currency/interfaces';

const SEK: Currency = {
    name: 'Swedish Krona',
    demonym: 'Swedish',
    majorSingle: 'Krona',
    majorPlural: 'Kronor',
    codeNumeric: '752',
    symbol: 'kr',
    symbolNative: 'kr',
    minorSingle: 'Öre',
    minorPlural: 'Öre',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'SEK',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default SEK;
